import { actions, INSTRUMENT_STORE_NAME } from './store';
import { frontendActions } from '@cmctechnology/webinvest-store-frontend';
import { CmcWebApi } from '@cmctechnology/webinvest-api-client-web-trading';
import { Dispatch } from '@reduxjs/toolkit';
import { IEsgDataResponse, InstrumentCode } from './types';
import { GetState, getUnfetchedInstruments, INSTRUMENT_API_NAMES } from './actions';

const CONTROVERSY_NAME_DELIMITER = ';';
const PRODUCT_INVOLVEMENT = 'ProductInvolvement';
const INVOLVEMENT = 'Involvement';

export const transformEsgData = (raw: CmcWebApi.Research.ESGDataResponse1): IEsgDataResponse => {
  const { IsSuccess: isSuccess, ErrorMessage: errorMessage, ESGData: esgData } = raw;
  if (!isSuccess || !esgData) {
    return { isSuccess, errorMessage };
  }

  const esgDataObject = esgData as any;
  const productInvolvements = Object.keys(esgDataObject)
    .filter((key) => key.includes(INVOLVEMENT) && esgDataObject[key] === true)
    .map((key) =>
      key
        .replace(PRODUCT_INVOLVEMENT, '')
        .replace(INVOLVEMENT, '')
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase())
        .trim()
    );

  const controversies = esgData.HighestControversyLevelControversyName?.split(CONTROVERSY_NAME_DELIMITER) ?? [];

  const {
    EsgRiskScore: esgRiskScore,
    EnvironmentRiskScore: environmentRiskScore,
    SocialRiskScore: socialRiskScore,
    GovernanceRiskScore: governanceRiskScore,
    EsgRiskCategory: esgRiskCategory,
    HighestControversyLevelAnswerCategory: highestControversyLevelAnswerCategory,
    HighestControversyLevelCategory: highestControversyLevelCategory,
    ExtractionDate: extractionDate
  } = esgData;

  return {
    isSuccess: true,
    esgData: {
      productInvolvements,
      controversies,
      esgRiskScore,
      environmentRiskScore,
      socialRiskScore,
      governanceRiskScore,
      esgRiskCategory,
      highestControversyLevelAnswerCategory,
      highestControversyLevelCategory,
      extractionDate
    }
  };
};

/**
 * Pass in single instrument code to fetch, requested only if hasn't been fetched.
 * @param instrument
 * @returns
 */
export const fetchEsg = (instrument: InstrumentCode) => {
  return async (dispatch: Dispatch<any>, getState: GetState) => {
    const [toFetch] = getUnfetchedInstruments(instrument, 'esg', getState);
    if (!toFetch) return;
    const request: CmcWebApi.Research.ESGDataRequest1 = { Stock: toFetch };
    try {
      const response = await frontendActions.webTradingApiCall<CmcWebApi.Research.ESGDataResponse1>(
        INSTRUMENT_STORE_NAME,
        INSTRUMENT_API_NAMES.ResearchESGDataGet1,
        request,
        dispatch,
        toFetch
      );
      dispatch<any>(actions.esgFetched({ instrument: toFetch, response: transformEsgData(response) }));
    } catch {}
  };
};
